/*
 * @Author: 冯杰
 * @Date: 2021-07-13 17:45:58
 * @LastEditTime: 2024-10-10 11:26:58
 * @FileName: 文件名
 */
import Vue from '@/found/main';
import { Message } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import precise from './utils/precise';
import Storage from './utils/storage';

Vue.use(precise);
// Vue.config.productionTip = false;

// 渠道分利 海普终端只有 sysadmin 账号可以看见
const sysAdminWhitePath = [
  '/cps_web/haipu_terminal/cash_withdrawal_details',
  '/cps_web/haipu_terminal/contract_management',
];
const sysAdminWhitePathFunction = (next) => {
  const user = Storage.l.get('userInfo') ? JSON.parse(Storage.l.get('userInfo')) : {};
  if (user.userName === 'sysadmin') {
    next();
  } else {
    Message.error('您无权进入此页面，已为您导航至首页！');
    next('/home');
  }
};

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('TokenKey');
  // if (to.meta.title && typeof to.meta.title === 'string') {
  //   document.title = to.meta.title;
  // }
  if (token) {
    if (!store.state.menus.menusName.length) {
      store.dispatch('menus/getMenusNavList').then((res) => {
        if (res.length > 0 && to.path.indexOf('/login') === 0) {
          next({ path: res[0].path !== 'census' ? res[0].path : '/' });
        } else if (res.length > 0 && to.redirectedFrom) {
          const path = res[0].path !== 'census' && to.redirectedFrom === '/';
          next(path ? res[0].path : to.redirectedFrom);
        } else if (sysAdminWhitePath.includes(to.path)) {
          sysAdminWhitePathFunction(next);
        } else {
          next();
        }
      }).catch((err) => {
        next();
        console.log(err);
      });
    } else if (sysAdminWhitePath.includes(to.path)) {
      sysAdminWhitePathFunction(next);
    } else {
      next();
    }
  } else if (!token && to.path !== '/login') {
    next('/login');
  } else {
    next();
  }
});

window.App = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
